// extracted by mini-css-extract-plugin
export var notificationHost = "_mn-0";